import { createBrowserRouter } from "react-router-dom";
import CompetencyMapsList from "pages/CompetencyMaps/list";
// import KnowledgeBlocksList from "pages/KnowledgeBlocks/list";
import TestingList from "pages/Testing/list";
import CompetencyMapView from "pages/CompetencyMaps/view";
import KnowledgeBlockView from "pages/KnowledgeBlocks/view";
import SkillView from "pages/Skill/view";
import TestingView from "pages/Testing/view/Personal";
import Login from "pages/Login";
import ROUTES from "constants/routes";
import UserRegister from "pages/Register/UserRegister";
import CompanyRegister from "pages/Register/CompanyRegister";
import CompanyPage from "pages/CompanyPage";
import ProfilePage from "pages/Profile";
import ExaminationView from "pages/Testing/view/Group";
import CandidateView from "pages/Candidate/view";
import CandidateListPage from "pages/Candidate/list";
import QuestionView from "pages/Question/view";
import VacancyView from "pages/Vacancies/view";
import VacanciesList from "pages/Vacancies/list";
import ExaminationLayout from "layout/ExaminationLayout";
import MainLayout from "./layout/MainLayout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: <Login />,
      },
      {
        path: ROUTES.USER_REGISTER,
        element: <UserRegister />,
      },
      {
        path: ROUTES.COMPANY_REGISTER,
        element: <CompanyRegister />,
      },
      {
        path: ROUTES.COMPANY,
        element: <CompanyPage />,
      },
      {
        path: ROUTES.PROFILE,
        element: <ProfilePage />,
      },
      {
        path: ROUTES.COMPETENCE_MAPS,
        children: [
          {
            index: true,
            element: <CompetencyMapsList />,
          },
          {
            path: "view/:mapId",
            element: <CompetencyMapView />,
          },
          {
            path: "create",
            element: <CompetencyMapView />,
          },
        ],
      },
      {
        path: ROUTES.KNOWLEDGE_BLOCKS,
        children: [
          // TODO: при отсутствии index: true отображается пустая страница, то же самое с ROUTES.SKILL, пофиксить
          // TODO: завершить скрытие страницы
          // {
          //   index: true,
          //   element: <KnowledgeBlocksList />,
          // },
          {
            path: "view/:knowledgeBlockId",
            element: <KnowledgeBlockView />,
          },
          {
            path: "create",
            element: <KnowledgeBlockView />,
          },
        ],
      },
      {
        path: ROUTES.TESTING,
        children: [
          {
            index: true,
            element: <TestingList />,
          },
          {
            element: <ExaminationLayout />,
            children: [
              {
                path: "view/personal/:id",
                element: <TestingView />,
              },
              {
                path: "create/personal",
                element: <TestingView />,
              },
              {
                path: "view/group/:id",
                element: <ExaminationView />,
              },
              {
                path: "create/group",
                element: <ExaminationView />,
              },
            ],
          },
        ],
      },
      {
        path: ROUTES.SKILL,
        children: [
          {
            path: "view/:skillId",
            element: <SkillView />,
          },
          {
            path: "create",
            element: <SkillView />,
          },
        ],
      },
      {
        path: ROUTES.CANDIDATE,
        children: [
          {
            index: true,
            element: <CandidateListPage />,
          },
          {
            path: "view/:candidateId",
            element: <CandidateView />,
          },
          {
            path: "create",
            element: <CandidateView />,
          },
        ],
      },
      {
        path: ROUTES.QUESTION,
        children: [
          {
            path: "view/:id",
            element: <QuestionView />,
          },
          {
            path: "create",
            element: <QuestionView />,
          },
        ],
      },
      {
        path: ROUTES.VACANCIES,
        children: [
          {
            index: true,
            element: <VacanciesList />,
          },
          {
            path: "view/:vacancyId",
            element: <VacancyView />,
          },
          {
            path: "create",
            element: <VacancyView />,
          },
        ],
      },
    ],
  },
]);

export default router;
